// components/suiro_extract_optional_powerplant_list.jsx
import { SuiroExtractTable } from './suiro/suiro_extract_table'; 
import { OptionalTableHeader } from './suiro/optional/optional_table_header';
import { OptionalCommonRow } from './/suiro/optional/optional_common_row';
import { OptionalDataRow } from './suiro/optional/optional_data_row';

/**
 * 水路抜水（オプション/対象外選択可能）発電所リスト表示コンポーネント
 * * work_check.jsx から渡される全ての props を受け取り、SuiroExtractTable に委譲するラッパー。
 * 使用するヘッダー、共通行、データ行を設定する役割を担う。
 */
export const SuiroExtractOptionalPowerplantList = ({
    uuid,
    currentUser,
    title,
    resetRef,
    notReportRef,
    nameRef,
    tableRef,
    lefts,
    headerHeight,
    suiroExtractList, // work_check.jsx から渡されるリスト
    setSuiroExtractList, // work_check.jsx から渡されるリストセッター
    setOtherSuiroExtractList,
    users,
    partners,
    toggleColumn,
    resetFields // useSuiroHandlers が必要とするリセットフィールド
}) => {
    // work_check.jsx から渡された props をそのまま SuiroExtractTable に渡す
    return (
        <SuiroExtractTable
            uuid={uuid}
            currentUser={currentUser}
            type="optional" // 必須項目かオプション項目かを区別する
            title={title}
            
            // Ref / レイアウト情報
            resetRef={resetRef}
            notReportRef={notReportRef}
            nameRef={nameRef}
            tableRef={tableRef}
            lefts={lefts}
            headerHeight={headerHeight}
            
            // データとセッター
            suiroExtractList={suiroExtractList}
            setSuiroExtractList={setSuiroExtractList}
            setOtherSuiroExtractList={setOtherSuiroExtractList}
            users={users}
            partners={partners}
            
            // 共通行（OptionalCommonRow）の制御に必要なロジック
            toggleColumn={toggleColumn}
            
            // useSuiroHandlers に必要なリセットフィールド
            resetFields={resetFields}

            // 使用するコンポーネントの指定
            HeaderComponent={OptionalTableHeader}
            CommonRowComponent={OptionalCommonRow} // 全行共通の操作行
            DataRowComponent={OptionalDataRow} // 個別のデータ行
        />
    );
};